import React from "react";
import { CartState } from "../context/Context";
import Filters from "./Filters";
import Singleproducts2 from "./Singleproducts2";
import { Link } from "react-router-dom";

const Home2 = () => {
  const {
    state3: { product3 },
    productState: { sort, byStock, byFastDelivery, byRating, searchQuery },
  } = CartState();
//   console.log(product2);
const transformProducts = () => {
    let sortedProducts = product3;

    if (sort) {
      sortedProducts = sortedProducts.sort((a, b) =>
        sort === "lowToHigh" ? a.price - b.price : b.price - a.price
      );
    }

    if (!byStock) {
      sortedProducts = sortedProducts.filter((prod) => prod.inStock);
    }

    if (byFastDelivery) {
      sortedProducts = sortedProducts.filter((prod) => prod.fastDelivery);
    }

    if (byRating) {
      sortedProducts = sortedProducts.filter(
        (prod) => prod.ratings >= byRating
      );
    }

    if (searchQuery) {
      sortedProducts = sortedProducts.filter((prod) =>
        prod.name.toLowerCase().includes(searchQuery)
      );
    }

    return sortedProducts;
  };
  return (
    <>
      
      <nav id="navbar">
        <ul>
          <Link
            to="/prod"
            style={{ textDecoration: "none" }}
            onClick={() => {
              window.scroll({
                top: 0,
                 behavior:"instant",
              });
            }}
          >
            <li>Curtain Finials</li>
          </Link>
          <Link
            to="/prod2"
            style={{ textDecoration: "none" }}
            onClick={() => {
              window.scroll({
                top: 0,
                 behavior:"instant",
              });
            }}
          >
            <li>Curtain Channels</li>
          </Link>
          <Link
            to="/prod3"
            style={{ textDecoration: "none" }}
            onClick={() => {
              window.scroll({
                top: 0,
                 behavior:"instant",
              });
            }}
          >
            <li>Window Blinds </li>
          </Link>
        </ul>
      </nav>
      <div className="home container-fluid">
        <Filters />
        <div className="productContainer">
          {transformProducts().map((prod) => {
            return <Singleproducts2 prod={prod} key={prod.id} />;
          })}
        </div>
      </div>
    </>
  );
};

export default Home2;
